import React from "react";

export const DividedRow = (props) => {
  return <div className="row">{props.children}</div>;
};

export const Full = ({ labelFor, title, children }) => {
  return (
    <div className="full">
      {title && <label htmlFor={labelFor}>{title}</label>}
      {children}
    </div>
  );
};

export const Half = ({ hasCheckbox, labelFor, title, children }) => {
  return (
    <div className="half">
      {hasCheckbox ? (
        <>
          {children}
          <label htmlFor={labelFor}>{title}</label>
        </>
      ) : (
        <>
          <label htmlFor={labelFor}>{title}</label>
          {children}
        </>
      )}
    </div>
  );
};

export const Third = ({ hasCheckbox, labelFor, title, children }) => {
  return (
    <div className="third">
      {hasCheckbox ? (
        <>
          {children}
          <label htmlFor={labelFor}>{title}</label>
        </>
      ) : (
        <>
          <label htmlFor={labelFor}>{title}</label>
          {children}
        </>
      )}
    </div>
  );
};

export const Quarter = ({ hasCheckbox, labelFor, title, children }) => {
  return (
    <div className="quarter">
      {hasCheckbox ? (
        <>
          {children}
          <label htmlFor={labelFor}>{title}</label>
        </>
      ) : (
        <>
          <label htmlFor={labelFor}>{title}</label>
          {children}
        </>
      )}
    </div>
  );
};
